import WebApp from '@twa-dev/sdk';

export const addToHomeScreen = () => {
  WebApp.HapticFeedback.impactOccurred('light');
  WebApp.addToHomeScreen();
};
